import axios from 'axios';

import { SERVICEBASEURL } from 'enums/serviceBaseUrls';
import { Optional } from 'functions/promiseExtensions';

export function callApi(id: string): Promise<Optional<ResponseData>> {
	const url: string = `${SERVICEBASEURL.BACKEND}/Allergen/${id}`;
	return axios.get(url).toOptionalMapped((x) => x.data);
}

export interface Response {
	data: ResponseData;
}

export type ResponseData = {
	id: string;
	negativeIconSvg: IconSvg | null;
	positiveIconSvg: IconSvg | null;
	mayContainIconSvg: IconSvg | null;
	display: boolean;
	negativeNameTranslations: {
		[key: string]: string;
	};
	positiveNameTranslations: {
		[key: string]: string;
	};
	mayContainNameTranslations: {
		[key: string]: string;
	};
};

export type IconSvg = {
	id: string;
	url: string;
	availableSizes: number[];
};
